/* eslint-disable */
import * as React from "react";
import OrbitIcon from "../Icon";
export default function Bus(props) {
  var color = props.color,
      size = props.size,
      customColor = props.customColor,
      className = props.className,
      dataTest = props.dataTest,
      ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      reverseOnRtl = props.reverseOnRtl;
  return React.createElement(OrbitIcon, {
    viewBox: "0 0 24 24",
    size: size,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    d: "M18.25 13.426a.208.208 0 0 1-.208.208H5.958a.208.208 0 0 1-.208-.208V5.3c0-.46.373-.833.833-.833h10.834c.459 0 .833.373.833.833v8.126zm-2.5 3.333a.625.625 0 0 1-.625-.625c0-.345.28-.625.625-.625h1.667a.625.625 0 0 1 0 1.25H15.75zm-9.167 0a.625.625 0 0 1-.625-.625c0-.345.28-.625.625-.625H8.25a.625.625 0 0 1 0 1.25H6.583zM20.125 6.344a.206.206 0 0 1-.148-.062.204.204 0 0 1-.06-.149V5.3a2.5 2.5 0 0 0-2.5-2.5H6.583a2.5 2.5 0 0 0-2.5 2.5v.833a.209.209 0 0 1-.208.209h-.417A1.459 1.459 0 0 0 2 7.8v2.5c0 .805.653 1.457 1.458 1.458h.417c.115 0 .208.094.208.209v5.416c0 1.293-.019 2.357 1.24 2.487H5.2c.044 0 .087.012.119.04a.124.124 0 0 1 .049.099v1.396c0 .308.304.559.676.559h1.35c.372 0 .676-.251.676-.559v-1.41c0-.048.037-.09.088-.112h7.717a.18.18 0 0 1 .044.027.124.124 0 0 1 .049.099v1.396c0 .308.303.559.677.559h1.349c.372 0 .676-.251.676-.559v-1.41c0-.061.059-.11.13-.125h-.124c1.259-.13 1.241-1.194 1.241-2.487v-5.416c0-.115.093-.209.208-.209h.417A1.46 1.46 0 0 0 22 10.3V7.8a1.46 1.46 0 0 0-1.458-1.456h-.417z"
  }));
}